import type { Time_Entries } from "@/src/gql/graphql";

/**
 * Revenue for a time entry: only billable entries with a rate and hours earn
 * revenue (hours × billable_rate); everything else is 0. Pure — extracted
 * verbatim from the original TimeEntryDetails inline computation.
 */
export function computeTimeEntryRevenue(item: Time_Entries): number {
  return item.entry_type === "billable" && item.billable_rate && item.hours
    ? item.hours * item.billable_rate
    : 0;
}

/** Long "Month Day, Year" rendering of the date-worked column, "N/A" when absent. */
export function formatDateWorked(dateWorked: string | null | undefined): string {
  return dateWorked
    ? new Date(dateWorked).toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      })
    : "N/A";
}

/** Short "Mon Day, Year, HH:MM" rendering of a metadata timestamp, "N/A" when absent. */
export function formatMetadataTimestamp(value: string | null | undefined): string {
  return value
    ? new Date(value).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "N/A";
}
